'use client';

exports.getSession = () => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; sessionToken=`);

  if (parts.length === 2) {
    return decodeURIComponent(parts.pop().split(';').shift());
  }

  return null;
};

exports.createSession = (session, expiryDate) => {
  document.cookie = `sessionToken=${encodeURIComponent(
    session
  )}; path=/; Expires=${expiryDate}; secure; SameSite=strict`;
};

exports.deleteSession = () => {
  document.cookie = `sessionToken=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; secure; samesite=lax`;
};
